<div class="min-h-screen bg-gray-50">

  <!-- Header -->
  <app-header-nav></app-header-nav>

  <mat-toolbar class="border-b bg-white shadow-sm">
    <button mat-icon-button (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="text-xl font-semibold text-gray-800 ml-4">Inventory Management</h1>
    <span class="flex-auto"></span>
    <div class="flex gap-2">
      <button mat-raised-button color="accent" (click)="openBulkInventoryDialog()">
        <mat-icon>inventory_2</mat-icon> Add to Inventory
      </button>
      <button mat-raised-button color="primary" (click)="openAddEditDrinkDialog()">
        <mat-icon>add</mat-icon> Add New Drink
      </button>
    </div>
  </mat-toolbar>

  <div class="flex items-center justify-center h-screen" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>

  <div class="p-6 space-y-6" *ngIf="!isLoading">
    <!-- Overview Cards -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Total Items</mat-card-title>
          <mat-icon class="text-gray-500">inventory</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold">{{ getTotalDrinks() }}</div>
          <p class="text-xs text-gray-600">Drinks in inventory</p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Low Stock Alerts</mat-card-title>
          <mat-icon class="text-orange-500">warning</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold text-orange-500">{{ getLowStockItems() }}</div>
          <p class="text-xs text-gray-600">Items need restocking</p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Total Revenue</mat-card-title>
          <mat-icon class="text-green-500">trending_up</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold text-green-500">${{ getTotalRevenue() }}</div>
          <p class="text-xs text-gray-600">This week</p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header class="flex flex-row items-center justify-between space-y-0 pb-2">
          <mat-card-title class="text-sm">Categories</mat-card-title>
          <mat-icon class="text-gray-500">category</mat-icon>
        </mat-card-header>
        <mat-card-content>
          <div class="text-2xl font-bold">{{ getTotalCategories() }}</div>
          <p class="text-xs text-gray-600">Active categories</p>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Tabs -->
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Inventory Management">
        <div class="mt-4">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold">Inventory Management</h2>
          </div>

          <mat-card>
            <div class="mat-elevation-z2 rounded-lg overflow-hidden">
              <table mat-table [dataSource]="dataSource" matSort class="w-full">
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                  <td mat-cell *matCellDef="let drink">
                    <div>
                      <div class="font-medium">{{ drink.name }}</div>
                      <div class="text-sm text-gray-600">{{ drink.description }}</div>
                    </div>
                  </td>
                </ng-container>

                <!-- Category Column -->
                <ng-container matColumnDef="category">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
                  <td mat-cell *matCellDef="let drink">
                    <mat-chip>{{ drink.categoryName }}</mat-chip>
                  </td>
                </ng-container>

                <!-- Price Column -->
                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Price </th>
                  <td mat-cell *matCellDef="let drink"> ${{ drink.price }} </td>
                </ng-container>

                <!-- Stock Column -->
                <ng-container matColumnDef="stock">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Stock </th>
                  <td mat-cell *matCellDef="let drink">
                    <div class="flex items-center gap-2">
                      <input type="number" [value]="drink.stock" (change)="updateStock(drink, $event)"
                        class="w-20 px-2 py-1 border rounded" min="0" />
                      <mat-icon *ngIf="drink.stock < 5" class="text-orange-500 text-sm">warning</mat-icon>
                    </div>
                  </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                  <td mat-cell *matCellDef="let drink">
                    <mat-chip [color]="drink.isAvailable ? 'primary' : 'warn'">
                      {{ drink.isAvailable ? 'Available' : 'Unavailable' }}
                    </mat-chip>
                  </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions </th>
                  <td mat-cell *matCellDef="let drink">
                    <div class="flex gap-2">
                      <!-- Name, price, category and description had no way of
                           being changed: the dialog existed but nothing ever
                           opened it for an existing drink, so a typo in a name
                           or a price rise meant deleting and re-adding. -->
                      <button mat-icon-button color="primary" aria-label="Edit drink"
                              (click)="openAddEditDrinkDialog(drink)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-stroked-button size="small" (click)="toggleAvailability(drink)">
                        {{ drink.isAvailable ? 'Disable' : 'Enable' }}
                      </button>
                      <button mat-icon-button color="warn" (click)="deleteDrink(drink.id)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of drinks"></mat-paginator>
            </div>
          </mat-card>
        </div>
      </mat-tab>

      <mat-tab label="Category Analytics">
        <div class="mt-4">
          <h2 class="text-xl font-semibold mb-4">Category Analytics</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <mat-card *ngFor="let stat of getCategoryStats()">
              <mat-card-header>
                <mat-card-title class="text-lg">{{ stat.category }}</mat-card-title>
              </mat-card-header>
              <mat-card-content class="space-y-2">
                <div class="flex justify-between">
                  <span>Total Drinks:</span>
                  <span>{{ stat.totalDrinks }}</span>
                </div>
                <div class="flex justify-between">
                  <span>Total Stock:</span>
                  <span>{{ stat.totalStock }}</span>
                </div>
                <div class="flex justify-between">
                  <span>Low Stock:</span>
                  <span [class.text-orange-500]="stat.lowStock > 0">{{ stat.lowStock }}</span>
                </div>
                <div class="flex justify-between">
                  <span>Revenue:</span>
                  <span class="text-green-500">${{ stat.revenue }}</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Stock Alerts">
        <div class="mt-4">
          <h2 class="text-xl font-semibold mb-4">Stock Alerts</h2>
          <div *ngIf="getLowStockItems() > 0; else noAlerts" class="space-y-4">
            <mat-card *ngFor="let drink of getLowStockDrinks()" class="border-orange-200">
              <mat-card-content class="pt-6">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <mat-icon class="text-orange-500">warning</mat-icon>
                    <div>
                      <h3 class="font-medium">{{ drink.name }}</h3>
                      <p class="text-sm text-gray-600">
                        Only {{ drink.stock }} left in stock
                      </p>
                    </div>
                  </div>
                  <mat-chip color="warn" class="text-orange-500 border-orange-500">
                    Low Stock
                  </mat-chip>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <ng-template #noAlerts>
            <mat-card>
              <mat-card-content class="pt-6 text-center">
                <mat-icon class="text-green-500 text-5xl mb-4">inventory</mat-icon>
                <h3 class="text-lg font-medium">All Good!</h3>
                <p class="text-gray-600">No low stock alerts at the moment.</p>
              </mat-card-content>
            </mat-card>
          </ng-template>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Add New Drink Dialog -->
  <div *ngIf="showAddDrinkDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">{{ editingDrinkId ? 'Edit Drink' : 'Add New Drink' }}</h2>
        <button mat-icon-button (click)="closeAddDrinkDialog()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form (ngSubmit)="addNewDrink()" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <mat-form-field>
            <mat-label>Drink Name</mat-label>
            <input matInput [(ngModel)]="newDrink.name" name="name" required placeholder="Enter drink name">
          </mat-form-field>

          <mat-form-field>
            <mat-label>Category</mat-label>
            <mat-select [(ngModel)]="newDrink.categoryId" name="category" required>
              <mat-option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Price ($)</mat-label>
            <input matInput type="number" step="0.01" [(ngModel)]="newDrink.price" name="price" required
              placeholder="Enter price">
          </mat-form-field>

          <mat-form-field>
            <mat-label>Stock Quantity</mat-label>
            <input matInput type="number" [(ngModel)]="newDrink.stock" name="stock" required
              placeholder="Enter stock quantity">
          </mat-form-field>

          <mat-form-field class="md:col-span-2">
            <mat-label>Description</mat-label>
            <textarea matInput [(ngModel)]="newDrink.description" name="description"
              placeholder="Enter drink description" rows="3"></textarea>
          </mat-form-field>
        </div>

        <div class="flex gap-2 justify-end mt-6">
          <button mat-stroked-button type="button" (click)="closeAddDrinkDialog()">
            Cancel
          </button>
          <button mat-raised-button color="primary" type="submit">
            <mat-icon>{{ editingDrinkId ? 'save' : 'add' }}</mat-icon>
            {{ editingDrinkId ? 'Save Changes' : 'Add Drink' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Bulk Inventory Dialog -->
  <div *ngIf="showBulkInventoryDialog"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Bulk Inventory Management</h2>
        <button mat-icon-button (click)="closeBulkInventoryDialog()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <mat-form-field>
            <mat-label>Operation</mat-label>
            <mat-select [(ngModel)]="bulkOperation">
              <mat-option value="add">Add Stock</mat-option>
              <mat-option value="subtract">Subtract Stock</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Quantity</mat-label>
            <input matInput type="number" [(ngModel)]="bulkQuantity" placeholder="Enter quantity">
          </mat-form-field>

          <mat-form-field>
            <mat-label>Category Filter</mat-label>
            <mat-select [(ngModel)]="bulkCategoryFilter">
              <mat-option value="">All Categories</mat-option>
              <mat-option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="bg-gray-50 p-4 rounded-lg">
          <h3 class="text-lg font-semibold mb-2">Select Drinks to Update:</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 max-h-60 overflow-y-auto">
            <div *ngFor="let drink of getFilteredDrinks()"
              class="flex items-center space-x-2 p-2 bg-white rounded border">
              <mat-checkbox [(ngModel)]="drink.selected"></mat-checkbox>
              <div class="flex-1">
                <div class="font-medium">{{ drink.name }}</div>
                <div class="text-sm text-gray-600">Current: {{ drink.stock }} | {{ drink.categoryName }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex gap-2 justify-end mt-6">
          <button mat-stroked-button (click)="closeBulkInventoryDialog()">
            Cancel
          </button>
          <button mat-raised-button color="primary" (click)="applyBulkInventoryUpdate()">
            <mat-icon>inventory_2</mat-icon>
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Dialog -->
  <ng-template #deleteConfirmDialog>
    <h2 mat-dialog-title class="font-bold text-red-600">Delete Drink</h2>
    <mat-dialog-content>
      <p class="mb-4">Are you sure you want to delete this drink? This action cannot be undone.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="warn" (click)="confirmDelete()">Delete</button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Footer -->
  <app-footer></app-footer>
</div>